export default {
  headerTitle: 'Settings',
};
